import React from 'react';
import styles from './Footer.module.css';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

function Footer() {
  return (
    <footer id="footer" className={styles.footer}>
      <div className={styles.Scontainer}>
        <div className={styles.sircle}>
          <div className={styles.infosircle}>
            <FaEnvelope size={34} color="white" /> {/* Email icon */}
          </div>
          <p className={styles.fottertext}>Epost<br />Post@amdevelopment.no</p>
        </div>
        <div className={styles.sircle}>
          <div className={styles.infosircle}>
            <FaPhone size={34} color="white" /> {/* Phone icon */}
          </div>
          <p className={styles.fottertext}>Telefon<br />+47 469 42 484</p>
        </div>
        <div className={styles.sircle}>
          <div className={styles.infosircle}>
           <FaMapMarkerAlt size={34} color="white" /> {/* Map pin icon */}
          </div>
          <p className={styles.fottertext}>Kontor<br />Kjeldsbergveien 2, 9513 Alta</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
